import React from 'react';
import { useLocation } from 'react-router-dom';

const DashboardPage: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const section = searchParams.get('section');

  // Render different content based on the section
  const renderSectionContent = () => {
    switch (section) {
      case 'advertiser-campaigns':
        return (
          <div className="card card-accent-primary">
            <div className="card-header">
              <h3 className="card-title">Advertiser Campaigns</h3>
            </div>
            <div className="card-body">
              <p>This section is under development. Check back soon for advertiser campaign management.</p>
              <button className="btn btn-primary mt-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus me-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 5l0 14"></path>
                  <path d="M5 12l14 0"></path>
                </svg>
                Create Campaign
              </button>
            </div>
          </div>
        );
      case 'advertiser-creatives':
        return (
          <div className="card card-accent-primary">
            <div className="card-header">
              <h3 className="card-title">Advertiser Creatives</h3>
            </div>
            <div className="card-body">
              <p>This section is under development. Check back soon for creative management.</p>
            </div>
          </div>
        );
      case 'advertiser-reports':
        return (
          <div className="card card-accent-primary">
            <div className="card-header">
              <h3 className="card-title">Advertiser Reports</h3>
            </div>
            <div className="card-body">
              <p>This section is under development. Check back soon for advertiser reporting.</p>
            </div>
          </div>
        );
      case 'publisher-sites':
        return (
          <div className="card card-accent-info">
            <div className="card-header">
              <h3 className="card-title">Publisher Sites</h3>
            </div>
            <div className="card-body">
              <p>This section is under development. Check back soon for site management.</p>
            </div>
          </div>
        );
      case 'publisher-zones':
        return (
          <div className="card card-accent-info">
            <div className="card-header">
              <h3 className="card-title">Publisher Zones</h3>
            </div>
            <div className="card-body">
              <p>This section is under development. Check back soon for zone management.</p>
            </div>
          </div>
        );
      case 'publisher-reports':
        return (
          <div className="card card-accent-info">
            <div className="card-header">
              <h3 className="card-title">Publisher Reports</h3>
            </div>
            <div className="card-body">
              <p>This section is under development. Check back soon for publisher reporting.</p>
            </div>
          </div>
        );
      case 'balance':
        return (
          <div className="card card-accent-success">
            <div className="card-header">
              <h3 className="card-title">Account Balance</h3>
            </div>
            <div className="card-body">
              <div className="d-flex align-items-baseline">
                <div className="stats-value mb-0 me-2">$0.00</div>
              </div>
              <p className="mt-3">Your current account balance. Deposit funds to start advertising.</p>
              <button className="btn btn-primary mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus me-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 5l0 14"></path>
                  <path d="M5 12l14 0"></path>
                </svg>
                Add Funds
              </button>
            </div>
          </div>
        );
      case 'analytics':
        return (
          <div className="card card-accent-warning">
            <div className="card-header">
              <h3 className="card-title">Analytics</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-3">Performance Overview</h4>
                      <div className="d-flex align-items-center mb-3">
                        <div className="subheader">Impressions</div>
                        <div className="ms-auto lh-1">
                          <div className="text-muted">Last 7 days</div>
                        </div>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <div className="stats-value mb-0 me-2">0</div>
                      </div>
                      <div className="mt-3">
                        <div className="progress progress-sm">
                          <div className="progress-bar bg-primary" style={{ width: '0%' }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title mb-3">Revenue</h4>
                      <div className="d-flex align-items-center mb-3">
                        <div className="subheader">Earnings</div>
                        <div className="ms-auto lh-1">
                          <div className="text-muted">Last 7 days</div>
                        </div>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <div className="stats-value mb-0 me-2">$0.00</div>
                      </div>
                      <div className="mt-3">
                        <div className="progress progress-sm">
                          <div className="progress-bar bg-success" style={{ width: '0%' }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p className="mt-3">Analytics dashboard is under development. More detailed metrics will be available soon.</p>
              <div className="mt-3">
                <button className="btn btn-primary me-2">View Reports</button>
                <button className="btn btn-secondary">Export Data</button>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <>
            <div className="col-12">
              <div className="card card-accent-primary">
                <div className="card-header">
                  <h3 className="card-title">Overview</h3>
                </div>
                <div className="card-body">
                  <p>Welcome to your bidmatch.ai dashboard. Use the navigation menu to access different sections.</p>
                  <div className="mt-3">
                    <button className="btn btn-primary me-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-rocket me-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"></path>
                        <path d="M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"></path>
                        <path d="M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                      </svg>
                      Get Started
                    </button>
                    <button className="btn btn-secondary">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-file-text me-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                        <path d="M9 9l1 0"></path>
                        <path d="M9 13l6 0"></path>
                        <path d="M9 17l6 0"></path>
                      </svg>
                      Documentation
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card card-accent-warning">
                <div className="card-header">
                  <h3 className="card-title">Quick Stats</h3>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="subheader">Campaigns</div>
                    <div className="ms-auto lh-1">
                      <div className="text-muted">Active</div>
                    </div>
                  </div>
                  <div className="d-flex align-items-baseline">
                    <div className="stats-value mb-0 me-2">0</div>
                    <div className="me-auto">
                      <span className="text-green d-inline-flex align-items-center lh-1">
                        0% 
                      </span>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="progress progress-sm">
                      <div className="progress-bar bg-warning" style={{ width: '0%' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card card-accent-info">
                <div className="card-header">
                  <h3 className="card-title">Recent Activity</h3>
                </div>
                <div className="card-body">
                  <p>No recent activity to display.</p>
                  <button className="btn btn-info btn-sm mt-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-refresh me-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path>
                      <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path>
                    </svg>
                    Refresh
                  </button>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-lg-4">
              <div className="card card-accent-success">
                <div className="card-header">
                  <h3 className="card-title">Account Balance</h3>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-baseline">
                    <div className="stats-value mb-0 me-2">$0.00</div>
                  </div>
                  <button className="btn btn-primary btn-sm mt-3">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus me-1" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M12 5l0 14"></path>
                      <path d="M5 12l14 0"></path>
                    </svg>
                    Add Funds
                  </button>
                </div>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div className="row row-deck row-cards">
      {section ? (
        <div className="col-12">
          {renderSectionContent()}
        </div>
      ) : (
        renderSectionContent()
      )}
    </div>
  );
};

export default DashboardPage;